import { WidgetTimeLineValue } from './widget-time-line-value-dto';

export class WidgetBarValue extends WidgetTimeLineValue {

}



